export const AUTHENTICATE = "admin/login";
export const CHANGE_PASSWORD = "admin/change-password";
export const FORGOT_PASSWORD = "admin/forgot-password";
export const RESET_PASSWORD = "admin/reset-password";
export const GET_USER_DETAILS_CREATE_PASSWORD = "admin/profile-detail";
export const UPDATE_USER_DETAILS_CREATE_PASSWORD = "admin/create-password";

// User API Routes
export const USER = "admin/user";
export const USERLIST = "admin/user-list";
export const USER_ACTIVE = "admin/user/activate";

// Common Master Routes
export const USER_IMAGE_UPLOAD = "master/imageUpload?requestFor=user";
export const MULTIPLE_IMAGES = "master/imageUpload";
export const UPLOAD_PHOTO_REFERENCE_FILE =
  "master/imageUpload?requestFor=training_photo";
export const COUNTRIES_LIST = "master/country";
export const STATES_LIST = "master/state";
export const CITIES_LIST = "master/city";

// Payment API Routes
export const ADD_CUSTOMER = "payment/customer/add";
export const EDIT_CUSTOMER = "payment/customer/edit";
export const GET_CUSTOMER = "payment/customer/find";
export const CUSTOMER_IMAGE_UPLOAD = "payment/customer/imageUpload";
export const ADD_SUBSCRIPTION = "payment/subscription/add";
export const UPDATE_SUBSCRIPTION = "payment/subscription/update";
export const FIND_BY_SUBSCRIPTION_ID = "payment/subscription/find";
export const SUBSCRIPTION_LIST = "payment/subscription/list";
export const FIND_CUSTOMER_SUBSCRIPTION =
  "/payment/subscription/findcustomersubscription";
export const UPDATE_STRIPE_SUBSCRIPTION =
  "/payment/subscription/updateinstripe";
export const SEND_PAYMENT_LINK = "payment/subscription/sendpaymentlink";
export const COUPON_LIST = "payment/coupon/list";
export const QUOTE_BY_CUSTOMER_ID = "payment/quotes/findbycustomer";
// Customer API Routes
export const CUSTOMERLIST = "admin/customer-list";
export const SUBSCRIPTIONLIST = "payment/subscription/list";
export const EXPORTTOEXCEL = "/admin/export-customer";
export const CUSTOMER_ACTIVE = "/payment/subscription/active";
export const CUSTOMER_INACTIVE = "/payment/subscription/inactive";
export const CUSTOMER_SUBSCRIPTION_CANCEL = "/payment/subscription";
export const ADMIN_IMPERSONATE = "/admin/impersonate";
export const UPDATE_BILLING_DETAILS =
  "payment/subscription/updatebillingdetails";
export const GET_CUSTOMER_PAYMENT_METHOD_DETAIL = "/payment/paymentmethod";
export const CUSTOMER_ACTIVE_EMPLOYEE = "admin/customer-active-employee";
export const RESEND_INVITE = "/admin/reinvite";

// Dashboard
export const STATISTICS = "/admin/dashboard";

//subscription master
export const GET_SUBSCRIPTION_PRODUCTS =
  "payment/subscriptionmaster/listproducts";
export const ADD_SUBSCRIPTION_MASTER = "payment/subscriptionmaster/add";
export const SUBSCRIPTION_MASTER = "payment/subscriptionmaster";
export const SUBSCRIPTION_MASTER_LIST = "payment/subscriptionmaster/list";
export const MASTER_SUBSCRIPTION_LIST =
  "payment/subscriptionmaster/listsubscription";
export const UPDATE_SUBSCRIPTION_MASTER =
  "payment/subscriptionmaster/updatestatus";
